<template>
    <div>
        <div v-if="loading" class="stl-loading" style="padding: 16px;">
            <b-spinner small variant="secondary" />
            <span>사용량 조회 중...</span>
        </div>

        <div v-else-if="data" class="stl-defs" :class="{ 'stl-defs--two': isGas }">
            <div class="df">
                <div class="dk">총 사용량</div>
                <div class="dv num">{{ fmtUsage(data.masterUsageQty) }}<small>{{ unitText }}</small></div>
            </div>
            <div class="df">
                <div class="dk">전체 세대 사용량</div>
                <div class="dv num">{{ fmtUsage(data.subUsageSumQty) }}<small>{{ unitText }}</small></div>
            </div>
            <div v-if="!isGas" class="df">
                <div class="dk">공용부 사용량</div>
                <div class="dv num">{{ fmtUsage(data.commonUsageQty) }}<small>{{ unitText }}</small></div>
            </div>
        </div>

        <div v-else class="stl-empty" style="padding: 14px;">
            <p>청구월을 선택하면 사용량이 표시됩니다.</p>
        </div>
    </div>
</template>

<script>
import { fmtUsage, unitLabel } from "../utils/settlementFormat.js";

export default {
    name: "ReconcileSummary",
    props: {
        data: { type: Object, default: null },
        loading: { type: Boolean, default: false },
        /** kWh | Nm3 — energySource에 따른 표시 단위 */
        usageUnit: { type: String, default: "kWh" },
    },
    computed: {
        unitText() {
            return unitLabel(this.usageUnit);
        },
        isGas() {
            return this.usageUnit === "Nm3";
        },
    },
    methods: { fmtUsage },
};
</script>

<style scoped>
.stl-defs--two {
    grid-template-columns: repeat(2, 1fr);
}
</style>
